import crudApi from "./crudApi";
import {API_STATUS} from '../api.js';

class Status extends crudApi {};
export default new Status(API_STATUS);
